import { render } from "./TheLatencyAlert.vue?vue&type=template&id=13fa6630"
import script from "./TheLatencyAlert.vue?vue&type=script&lang=js"
export * from "./TheLatencyAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__